import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFilter as setStateFilter } from "../../actions/overview";
import DatePicker from "react-datepicker";
import moment from "moment";

// const tillDate = useDateFormInput({
//     name: "Datum tot",                               // Title
//     columnIdentifier: "start_datetime_before",       // Column to use from the db
//     identifier: "course-filter",                     // Filter group identifier
//     resultFormat: "YYYY-MM-DD",                      // Format to use for the value passed to the backend.
//     minDate: "start_datetime_after",                 // Optional minimum date field
//     maxDate: "end_datetime_after"                    // Optional maximum date field
// });

// Creates a Date input selector
export function useDateFormInput(props) {
    const dispatch = useDispatch();
    const getValueFromState = (field) => useSelector((state) => state.OverviewState?.[JSON.stringify(props.identifier)]?.filter?.[field]) || null;

    let state = getValueFromState(props.columnIdentifier);

    const pickerProps = {};
    if (props.minDate) {
        const minDate = getValueFromState(props.minDate);
        if (minDate) {
            pickerProps.minDate = minDate;
        }
    }
    if (props.maxDate) {
        const maxDate = getValueFromState(props.maxDate);
        if (maxDate) {
            pickerProps.maxDate = maxDate;
        }
    }

    const setFilter = (val) => {
        dispatch(
            setStateFilter(props.identifier, {
                columnIdentifier: props.columnIdentifier,
                value: val
            })
        );
    };

    const content = (
        <>
            <DatePicker
                onChange={(momentVal) => {
                    let value = "";
                    if (momentVal != null && momentVal._isAMomentObject) {
                        value = momentVal.format("YYYY-MM-DD");
                    }
                    // setResult(value);
                    // setMomentResult(momentVal);
                    setFilter(momentVal);
                }}
                onChangeRaw={(event) => {
                    let value = event.target.value.split("-").join("");
                    let newDate = value.substring(0, 2);
                    if (value.length >= 3) {
                        newDate += "-" + value.substring(2, 4);
                    }
                    if (value.length >= 5) {
                        newDate += "-" + value.substring(4, 8);
                    }
                    event.target.value = newDate;
                }}
                className="form-control"
                placeholder="Kies een datum (dd-mm-yyyy)"
                selected={state ? moment(state) : null}
                autoComplete="off"
                {...pickerProps}
            />
            {state !== null && (
                <span
                    className={"filter-reset-button"}
                    onClick={(e) => {
                        e.target.value = "";
                        // setResult(null);
                        // setMomentResult(null);
                        setFilter(null);
                        e.preventDefault();
                    }}
                >
                    Reset filter
                </span>
            )}
        </>
    );

    return {
        content,
        resultObj: {
            columnIdentifier: props.columnIdentifier,
            result: state ? moment(state).format(props.resultFormat || "YYYY-MM-DD") : null
        },
        result: state ? moment(state).format(props.displayFormat || "YYYY-MM-DD") : null,
        name: props?.name || "Geen naam opgegeven",
        reset: () => setFilter(null),
        setResult: (o) => setFilter(o)
    };
}
